import logo from "@/assets/logo-ad4you.webp";

const Footer = () => {
  return (
    <footer className="border-t border-border py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Logo Ad4You Pages - Agência de criação de sites" className="h-8 opacity-70" width={87} height={32} loading="lazy" />
          </div>
          <div className="flex flex-col items-center gap-1">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Agência Ad4You. Todos os direitos reservados.
            </p>
            <p className="text-xs text-muted-foreground">
              pages.agenciaad4you.com.br
            </p>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="/privacidade"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors underline"
            >
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;